/**
The main entry point for the account section.

Referenced by the customers.liquid templates.
* */
import Account from './apps/customers/account';
import Order from './apps/customers/order';
import './scss/templates/customers.scss'; // TODO: break these up into different entry points if this gets too big?

if (document.querySelector('#account')) {
  Account();
}

if (document.querySelector('#fulfillments')) {
  Order();
}